// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var Sentry = require("../../reason/Sentry.bs.js");
var TanDate = require("../../reason/common/types/TanDate.bs.js");
var DateFns = require("date-fns");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
var MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MyDraftsWidgetRelay = require("../drafts/MyDraftsWidgetRelay.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var MyClientsWidgetRelay = require("../client/myClientsWidget/MyClientsWidgetRelay.bs.js");
var ReactErrorBoundary = require("react-error-boundary");
var MySharedPostsWidgetRelay = require("../sharing/sharedPosts/MySharedPostsWidgetRelay.bs.js");
var MyBroadcastMessagesWidgetRelay = require("../messages/MyBroadcastMessagesWidgetRelay.bs.js");
var MyDashboardPageRelayQuery_graphql = require("../../__generated__/MyDashboardPageRelayQuery_graphql.bs.js");

var convertVariables = MyDashboardPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = MyDashboardPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = MyDashboardPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, MyDashboardPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, MyDashboardPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(MyDashboardPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(MyDashboardPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(MyDashboardPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(MyDashboardPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function MyDashboardPageRelay$Greet(props) {
  var hour = DateFns.getHours(TanDate.now());
  var greeting = hour > 5 && hour < 12 ? "Good morning" : (
      hour >= 12 && hour < 17 ? "Good afternoon" : (
          hour >= 17 && hour < 20 ? "Good evening" : "Hi"
        )
    );
  return JsxRuntime.jsx(PageUITitle.make, {
              title: greeting + " <b>" + props.name + "</b>"
            });
}

var Greet = {
  make: MyDashboardPageRelay$Greet
};

function MyDashboardPageRelay$ErrorState(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
              children: JsxRuntime.jsx(ErrorComponent.make, {
                    message: "There was a problem loading your data. Please refresh or try again later."
                  })
            });
}

var ErrorState = {
  make: MyDashboardPageRelay$ErrorState
};

function MyDashboardPageRelay$LoadingState(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Loader.make, {}),
              className: "flex justify-center items-center grow h-full"
            });
}

var LoadingState = {
  make: MyDashboardPageRelay$LoadingState
};

function MyDashboardPageRelay$default(props) {
  var data = use({
        viewId: "Dashboard"
      }, undefined, undefined, undefined);
  var currenUserInfo = UserSession.useCurrentUserInfo();
  var tmp;
  if (currenUserInfo !== undefined) {
    switch (currenUserInfo.__typename) {
      case "Agent" :
      case "RegisteredClient" :
          tmp = currenUserInfo.firstName;
          break;
      case "__unselected" :
          tmp = "";
          break;
      
    }
  } else {
    tmp = "";
  }
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return JsxRuntime.jsx(MyDashboardPageRelay$ErrorState, {});
                }),
              children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
                    loaderComponent: Caml_option.some(JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {})),
                    children: JsxRuntime.jsxs(MarkupHelpers.Container.make, {
                          children: [
                            JsxRuntime.jsx(MyDashboardPageRelay$Greet, {
                                  name: tmp
                                }),
                            JsxRuntime.jsxs(ViewStack.make, {
                                  children: [
                                    JsxRuntime.jsx(MyClientsWidgetRelay.make, {
                                          query: data.fragmentRefs,
                                          viewMoreMode: "ShowAllButton"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(MyDraftsWidgetRelay.make, {
                                                query: data.fragmentRefs,
                                                viewMoreMode: "ShowAllButton"
                                              }),
                                          id: "drafts"
                                        }),
                                    JsxRuntime.jsx(MyBroadcastMessagesWidgetRelay.make, {
                                          query: data.fragmentRefs,
                                          viewMoreMode: "ShowAllButton"
                                        }),
                                    JsxRuntime.jsx(MySharedPostsWidgetRelay.make, {
                                          query: data.fragmentRefs,
                                          viewMoreMode: "ShowAllButton"
                                        })
                                  ]
                                })
                          ]
                        })
                  }),
              onError: (function (error) {
                  Sentry.captureException(error, "MyDashboardPageRelay.res", undefined, undefined, undefined);
                })
            });
}

var PageTitle;

var Container;

var $$default = MyDashboardPageRelay$default;

exports.Query = Query;
exports.PageTitle = PageTitle;
exports.Container = Container;
exports.Greet = Greet;
exports.ErrorState = ErrorState;
exports.LoadingState = LoadingState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
